
/// <amd-module name="VSSUI/Utils/CustomizedScreen" />
import * as React from "react";
import { IObservableValue, ObservableValue } from "VSS/Core/Observable";

export const enum ScreenBreakpoints {
    /**
     * Breakpoint used to react which usually corresponds to a mobile screen < 750px.
     */
    xsmall = 1,

    /**
     * Breakpoint used to react when the screen size >= 750px and less than
     * the next breakpoint if exists.
     */
    small = 750,

}

export const enum ScreenSize {
    xsmall = 0,
    small = 1,
}

export interface IScreenContext {
    /**
     * Specifies the size of the current window
     */
    size: IObservableValue<ScreenSize>;
}

class ScreenContextImp implements IScreenContext {
    public size: IObservableValue<ScreenSize>;

    constructor() {
        this.size = new ObservableValue<ScreenSize>(this.getCurrentSize());
        window.addEventListener("resize", this.onResize);
    }

    private getCurrentSize() {
        if (window.innerWidth >= ScreenBreakpoints.small) {
            return ScreenSize.small;
        } else {
            return ScreenSize.xsmall;
        }
    }

    private onResize = () => {
        const size = this.getCurrentSize();
        if (this.size.value !== size) {
            this.size.value = size;
        }
    };
}

export const ScreenContext = React.createContext<IScreenContext>(new ScreenContextImp());
